import { useState } from "react";
import { Link } from "react-router-dom";
import { BRAND, BUSINESSES, CAPABILITIES } from "@/data/content";
import LogoMark from "@/components/site/LogoMark";
import CookiePreferencesDialog from "@/components/site/CookiePreferencesDialog";

export default function Footer({ onJoin }) {
  const [cookieOpen, setCookieOpen] = useState(false);
  return (
    <footer data-testid="site-footer" className="bg-[#050505] text-white/70 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-14 grid grid-cols-12 gap-x-8 gap-y-10">
        <div className="col-span-12 md:col-span-4">
          <LogoMark
            variant="light"
            className="h-10 md:h-12 w-auto"
            testid="footer-logo-mark"
          />
          <p className="mt-6 text-sm leading-relaxed max-w-xs">
            {BRAND.tagline}
          </p>
          <p className="mt-3 text-xs text-white/40">blezzings.co</p>
        </div>

        <div className="col-span-6 md:col-span-2">
          <div className="overline" style={{ color: "#9CA3AF" }}>Capabilities</div>
          <ul className="mt-4 space-y-2">
            {CAPABILITIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/capabilities/${c.slug}`}
                  data-testid={`footer-capability-${c.slug}`}
                  className="text-sm hover:text-white transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline" style={{ color: "#9CA3AF" }}>BLEZZINGS Ecosystem</div>
          <ul className="mt-4 space-y-2">
            <li>
              <Link
                to="/ecosystem"
                data-testid="footer-nav-ecosystem"
                className="text-sm font-medium text-white/80 hover:text-white transition-colors"
              >
                Ecosystem Overview
              </Link>
            </li>
            {BUSINESSES.map((b) => (
              <li key={b.slug}>
                <Link
                  to={`/businesses/${b.slug}`}
                  data-testid={`footer-ecosystem-${b.slug}`}
                  className="text-sm hover:text-white transition-colors"
                >
                  {b.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline" style={{ color: "#9CA3AF" }}>Company</div>
          <ul className="mt-4 space-y-2">
            <li>
              <Link
                to="/leadership"
                data-testid="footer-nav-leadership-page"
                className="text-sm hover:text-white transition-colors"
              >
                Leadership
              </Link>
            </li>
            <li>
              <Link
                to="/insights"
                data-testid="footer-nav-insights"
                className="text-sm hover:text-white transition-colors"
              >
                Insights
              </Link>
            </li>
            <li>
              <Link
                to="/tools"
                data-testid="footer-nav-tools"
                className="text-sm hover:text-white transition-colors"
              >
                Growth Tools
              </Link>
            </li>
            <li>
              <Link
                to="/solutions"
                data-testid="footer-nav-solutions"
                className="text-sm font-medium text-white/80 hover:text-white transition-colors"
              >
                Solutions
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                data-testid="footer-nav-contact"
                className="text-sm hover:text-white transition-colors"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/how-we-engage"
                data-testid="footer-nav-how-we-engage"
                className="text-sm hover:text-white transition-colors"
              >
                How We Engage
              </Link>
            </li>
            <li>
              <Link
                to="/careers"
                data-testid="footer-join-btn"
                className="text-sm hover:text-white transition-colors"
              >
                Join Us
              </Link>
            </li>
          </ul>
          <div className="overline mt-8" style={{ color: "#9CA3AF" }}>Contact</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li className="text-white/50">Whitefield, Bengaluru</li>
            <li>
              <a href={BRAND.contact.phoneHref} className="hover:text-white transition-colors">
                {BRAND.contact.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${BRAND.contact.email}`} className="hover:text-white transition-colors">
                {BRAND.contact.email}
              </a>
            </li>
            <li>
              <a href={BRAND.contact.linkedinCompany} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} BLEZZINGS. All rights reserved.</div>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            <Link to="/privacy-policy" data-testid="footer-link-privacy-policy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" data-testid="footer-link-terms-of-use" className="hover:text-white transition-colors">
              Terms of Use
            </Link>
            <Link to="/sitemap" data-testid="footer-link-sitemap" className="hover:text-white transition-colors">
              Sitemap
            </Link>
            <button
              type="button"
              onClick={() => setCookieOpen(true)}
              data-testid="footer-cookie-preferences-btn"
              className="hover:text-white transition-colors"
            >
              Cookie Preferences
            </button>
          </div>
          <div>Strategy · Execution · Growth</div>
        </div>
      </div>
      <CookiePreferencesDialog open={cookieOpen} onOpenChange={setCookieOpen} />
    </footer>
  );
}
